import { Card } from "@/components/ui/card";
import useDocumentTitle from "@/components/ui/common/document-title";
import CheckInLogsTable from "./table";

export default function CheckInLogs() {
    useDocumentTitle("Check In Logs");

    return (
        <div className="w-full p-5">
            <Card className="pt-4">
                <CheckInLogsTable />
            </Card>
        </div>
    );
}